<template>
  <vs-popup :title="title" :active.sync="isActive">
    <div class="tenant-action-modal">
      <p class="mt-0 pt-0 font-medium">
        {{ requiresReason ? `Informe o motivo para ${normalizedAction.toLowerCase()} este tenant:` : `Clique em "${normalizedAction}" para confirmar a ação:` }}
      </p>

      <div v-if="requiresReason" class="mt-4">
        <vs-textarea
          v-model="reason"
          class="w-full"
          counter="2000"
          label="Motivo da exclusão/desativação"
        />
      </div>

      <div class="flex justify-end gap-3 mt-4">
        <vs-button type="border" @click="isActive = false">Cancelar</vs-button>
        <vs-button :disabled="confirmDisabled" @click="handleConfirm">{{ normalizedAction }}</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'TenantActionModal',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    actionLabel: {
      type: String,
      default: 'Confirmar'
    },
    loading: {
      type: Boolean,
      default: false
    },
    requiresReason: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirmar Ação'
    }
  },
  data() {
    return {
      reason: ''
    }
  },
  computed: {
    isActive: {
      get() {
        return this.active
      },
      set(value) {
        if (!value) {
          this.resetForm()
        }

        this.$emit('input', value)
      }
    },
    normalizedAction() {
      return this.actionLabel || 'Confirmar'
    },
    trimmedReason() {
      return this.reason.trim()
    },
    confirmDisabled() {
      return this.loading || (this.requiresReason && !this.trimmedReason)
    }
  },
  watch: {
    active(value) {
      if (!value) {
        this.resetForm()
      }
    }
  },
  methods: {
    handleConfirm() {
      if (this.requiresReason && !this.trimmedReason) {
        this.$vs.notify({
          color: 'warning',
          title: 'Motivo obrigatório',
          text: 'Informe o motivo da exclusão/desativação antes de continuar.'
        })
        return
      }

      this.$emit('confirm', this.trimmedReason)
    },
    resetForm() {
      this.reason = ''
    }
  }
}
</script>
